<template>
    <div class="planceindex spackage">
        <div class="blod">基本数据</div>
        <div class="key-data">
            <div class="box box-shadow bgc" v-for="(item,index) in keyData" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.tooltip" placement="top-start">
                    <i class="el-icon-warning"></i>
                </el-tooltip>
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <i class="icon overflow" :class="[item.type?'icon_index_1':'icon_index_2']"></i>
                </div>
            </div>
        </div>

       <div class="data-table">
           <div class="trendTitle">
               <el-tabs v-model="activeTitleName" @tab-click="handleTabClick" class="trendName">
                   <el-tab-pane label="贴子/资料数" name="first"></el-tab-pane>
                   <el-tab-pane label="用户" name="user"></el-tab-pane>
               </el-tabs>
               <el-tabs v-model="activeName" @tab-click="handleClick" class="tablist">
                   <el-tab-pane label="今日" name='0'></el-tab-pane>
                   <el-tab-pane label="昨日" name='1'></el-tab-pane>
                   <el-tab-pane label="近7日" name='6'></el-tab-pane>
                   <el-tab-pane label="近30日" name='29'></el-tab-pane>
                   <el-tab-pane name="zdy">
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleClick">
                            </el-date-picker>
                          </div>
                    </span>
                   </el-tab-pane>
               </el-tabs>
           </div>
           <!--<el-tabs v-model="activeName" @tab-click="handleClick">-->
           <!--</el-tabs>-->
           <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
       </div>
    </div>
</template>

<script>
    import { getBasicData, getStarProfile, getStarProfileByTime } from 'api/communityApi'
    import fecha from 'element-ui/src/utils/date';
    import {mapGetters, mapActions} from 'vuex'
    import LineReport from 'base/echarts/lineReportStar'

    export default {
        name: "index",
        data() {
            return {
                innerid: this.$route.query.innerid,
                keyData: [
                    {'title':'今日帖子数', total: 0, type:true, tooltip:'今日发布的贴子数量'},
                    {'title':'昨日贴子数', total: 0, type:true, tooltip:'昨日发布的贴子数量'},
                    {'title':'总成员数', total: 0, type:false, tooltip:'总共加入的成员数量'}
                ],
                param: {
                    date: [],
                    status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
                },
                activeTitleName: 'first',
                activeName: '0',
                lineDatas: {id: 'index', subText: '贴子数/资料数', xdata: [], data: []},
                tpm: {
                    type: 1,
                    beginTime: '',
                    endTime: ''
                    }
                }
            },
        activated: function() {
            // this.indexInfo()
        },
        methods: {
            handleTabClick(tab, event) {

                if (event.srcElement.className !== "el-tabs__item is-top is-active") {

                    const date = new Date()
                    let tpm = this.tpm

                    if (tpm.beginTime === '' && tpm.endTime === '') {
                        tpm.endTime = tpm.beginTime = this._time(date.getTime())
                    }

                    console.log('handleTabClick',tpm)
                    // tpm = {
                    // beginTime: this._time(date.getTime()),
                    // endTime: this._time(date.getTime())
                    // }

                    if (tab.name === 'first') {
                        tpm.type = 1
                        console.log('帖子/资料')
                    } else if (tab.name === 'user') {
                          tpm.type = 2
                        console.log('用户')
                    }

                    this._getIndexData(tpm)
                    // this.activeName = '0'
                }
            },
            handleClick(tab, event) {

                if (tab.name !== 'zdy') {
                    if (event.srcElement.className !== "el-tabs__item is-top is-active") {
                        const date = new Date(),
                            tpm = this.tpm
                        this.param.type = tab.type

                        if (tab.name === '0') {
                            tpm.beginTime = this._time(date.getTime())
                        } else {
                            tpm.beginTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        }

                        if (tab.name === '1') {
                            tpm.endTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        } else {
                            tpm.endTime = this._time(date.getTime())
                        }

                        this._getIndexData(tpm)
                    }
                }
                // console.log(tpm)
            },
            indexInfo() {
                const date = new Date(),
                    tpm = {
                        beginTime: this._time(date.getTime()),
                        endTime: this._time(date.getTime())
                    }
                this._getIndexData(tpm)
            },
            _getIndexData(tmp) {

                this.setLoading(true)

                getStarProfileByTime({
                    data: {
                        type: tmp.type?tmp.type:1,
                        starid: this.innerid,
                        beginTime: tmp.beginTime||tmp.begintime,
                        endTime: tmp.endTime||tmp.endtime
                    },
                    success: data => {
                        this.setLoading(false)

                        // 数据表
                        this.lineDatas.xdata = data.data.datelist

                        // 初始化数据

                        this.lineDatas.data = []
                        if (this.activeTitleName == 'first') {
                            this.lineDatas.data.push({
                                title: '贴子数',
                                color: '#1890FF',
                                list: data.data.subcountlist
                            })

                            this.lineDatas.data.push({
                                title: '资料数',
                                color: '#2FC25B',
                                list: data.data.filecountlist
                            })
                            this.lineDatas.legend = {
                                left: 'center',
                                data: ['贴子数', '资料数']
                            }
                            this.lineDatas.subText = '贴子数/资料数'

                        } else if (this.activeTitleName == 'user') {
                            this.lineDatas.data.push({
                                title: '用户',
                                color: '#1890FF',
                                list: data.data.membercountlist
                            })
                             this.lineDatas.data.push({
                                title: '',
                                color: '',
                                list: []
                            })
                            this.lineDatas.legend = {
                                left: 'center',
                                data: ['用户']
                            }
                            this.lineDatas.subText = '用户'
                            console.log('渲染用户')
                        }
                        console.log( this.lineDatas.data)


                        this.$nextTick(()=>{
                            this.keyData = this.keyData
                            this.lineDatas = this.lineDatas
                        })


                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(dta.msg)
                    }
                })
            },
            _time(time) {

                const temp = new Date(time);
                return fecha.format(temp, 'yyyy-MM-dd');
                //
                // time = new Date(time)
                // // 时间换算
                // var year = time.getFullYear(),
                //     month= time.getMonth()+1,
                //     date= time.getDate(),
                //     hour= time.getHours(),
                //     minute = time.getMinutes(),
                //     second = time.getSeconds()
                // return year+"-"+month+"-"+date;
            },

            // 星球概况用户数据
            _getStarProfile() {
                this.setLoading(true)
                getStarProfile({
                    data: {starid: this.innerid},
                    success:data => {
                        this.setLoading(false)
                        this.$nextTick(() => {
                            // 今日帖子
                            this.keyData[0].total = data.data.todaycount
                            // 昨日帖子
                            this.keyData[1].total = data.data.yescount
                            // 总成员
                            this.keyData[2].total = data.data.membercount
                        })
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })

            },
            ...mapActions(['setLoading'])
        },
        mounted() {
            this.indexInfo()
            this._getStarProfile()
        },
        watch: {
            'param.date': {
                handler(newV, oldV) {
                    let tpm = this.tpm
                    tpm.beginTime = this._time(newV[0])
                    tpm.endTime = this._time(newV[1])
                    // let tmp = this.tmp
                    // tmp = {
                    //     status: this.param.status,
                    //     begintime: this._time(newV[0]),
                    //     endtime:this._time(newV[1])
                    // };
                    // console.log('param.date',tmp)
                    this._getIndexData(tpm)
                }
            },
            deep: true
        },
        components: {
            LineReport
        },
        computed: {
            ...mapGetters(['loading'])
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .planceindex {
        .bold {
            font-weight: bold;
        }
        .trendTitle{
            margin-top: 24px;
            margin-bottom: 24px;
            /*padding-top: 4px;*/
            padding: 4px 10px 0 10px;
            height: 43px;
            border-bottom: solid 2px #E4E7ED;
            .trendName{
                flex-grow: 1;
            }
            .el-tabs__item {
                height: 45px;
            }
            .trendName,
            .tablist {
                float: left;
            }
            .tablist {
                float: right;
                /*width: calc(100% - 115.45px);*/
                .el-tabs__nav {
                    float: right;
                }
                .el-tabs__active-bar{
                    background: none!important;
                }
            }
            .el-tabs__nav{
                margin-left:20px;
                margin-right:20px;
            }
            .el-range-editor.el-input__inner{
                padding: 3px 5px;
            }
            .el-range-editor.el-input__inner{
                height: 32px;
                line-height: 32px;
            }
            .el-date-editor .el-range__icon{
                line-height: 26px;
            }
            .el-date-editor .el-range-separator{
                line-height: 26px;
            }
        }
        .key-data{
            display: block;
            margin-top: 14px;
            width: 100%;
            .item {
                float: right;
                width: auto;
                color: #C0C4CC;
                font-size: 14px;
                text-align: right;
                box-sizing: border-box;
            }
            .summary {
                clear: both;
                margin-left: 20px;
                margin-top: 6px;
                font-size: 14px;
            }
            .content{
                .num {
                    float: left;
                    margin-left: 20px;
                    margin-top: 12px;
                    font-size: 30px;
                    color: #303133;
                }
                .icon{
                    float: right;
                    margin-top: 12px;
                    margin-right: 10px;
                    min-width: 34px;
                    min-height: 34px;
                    width: 34px;
                    height: 34px;
                }
                .icon.icon_index_1 {
                    background: url("../../common/images/planetCommunity/index-1.png") center no-repeat;
                    background-size: 34px;
                }
                .icon.icon_index_2 {
                    background: url("../../common/images/planetCommunity/index-2.png") center no-repeat;
                    background-size: 34px;
                }
            }

            .box {
                padding: 10px;
                display: inline-block;
                margin-left: 40px;
                width: calc((100% - 80px) / 3);
                height: 120px;
                box-sizing: border-box;
            }
            .box:nth-child(1) {
                margin-left: 0;
            }
            .box:nth-child(1) .content .num {
                color: #409EFF;
            }
        }
        .data-table {
            margin-top: 20px;
            padding: 0 0;
            padding-bottom: 30px;
            box-sizing: border-box;
            background: #fff;

            .lineDatas {
                #index div {
                    width: 100px;
                }
                canvas {
                    width: 100%;
                }
            }
        }
    }
    /*菜单样式优化*/
    .el-menu-item-group__title{
        padding: 0 0 0 0;
    }
    .el-submenu .el-menu-item{
        padding-left: 45px!important;
    }
</style>
